<template>
  <div>
    <div class="backupRepository-title">
      <div>{{ $t("RAM.AWS.Backup.Repository.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:backup:replicationInstances:update'
          ]"
          :loading="modal_loading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          :loading="modal_loading"
          @click="exportList"
          v-hasPermission="[
            'resourceConfigurationManagement:aws:backup:replicationInstances:export'
          ]"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <div class="backupRepository-top">
      <backup-repository-search ref="search"></backup-repository-search>
    </div>
    <table-backup-repository></table-backup-repository>
  </div>
</template>

<script>
import BackupRepositorySearch from "../repository/BackupRepositorySearch";
import TableBackupRepository from "../repository/TableBackupRepository";

export default {
  name: "BackupRepository",
  components: {
    BackupRepositorySearch,
    TableBackupRepository
  },
  data() {
    return {
      modal_loading: false,
      companyId: ""
    };
  },
  methods: {
    update: function() {
      this.$api.resourceManagement
        .updateResource({
          resourceManagement: 27,
          accountType: 1
        })
        .then(res => {
          setTimeout(() => {
            this.$Message.success("更新成功");
          }, 1000);
        });
    },
    //导出
    exportList: function() {
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: "正在导出，请稍等..."
      });

      // 获取子组件数据
      this.companyId = this.$refs.search.companyId;
      this.accountName = this.$refs.search.accountName;
      this.backupVaultName = this.$refs.search.backupVaultName;
      // 下载Excel 文件
      this.$api.resourceManagement
        .exportAwsBackupVault({
          companyId: this.companyId,
          accountName: this.accountName,
          backupVaultName: this.backupVaultName
        })
        .then(res => {
          let fileName = "备份保管库.xls";
          let blob = new Blob([res.data], { type: "application/x-xls" });
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            window.URL.revokeObjectURL(link.href);
          }
          this.modal_loading = false;
          this.$Message.destroy();
          this.$Message.success("导出成功");
        });
    }
  }
};
</script>

<style scoped>
.backupRepository-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  overflow: hidden;
  font-weight: 600;
}
.backupRepository-title > div:nth-child(1) {
  float: left;
}
.backupRepository-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
.backupRepository-top {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/backup/repository/BackupRepository.vue